<div class="mt-2 flex flex-row justify-between">
  <div class="mt-2 w-25">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 25" xml:space="preserve">
      <path d="M82.4 23.3H55.9l6.6-21.9h24.7L76.9 11.7l-.4.5.3.6z" fill="#ffffff"></path>
      <path fill="#d41d52" d="M70.5 10.5h5.2l-4.2 3.1 1.6 5-4.1-3.1-4.2 3.1 1.7-5-4.2-3.1h5.1L69 5.7z"></path>
      <path
        d="M89 .6H9.2C8.1.6 7 1.5 6.7 2.5l-6 19.7c-.3 1 .3 1.9 1.4 1.9h81.4l-6.2-11.7L89 .6zm-6.9 22.6h-26l6.5-21.6h24.2L76.7 11.7l-.5.5.3.6 5.6 10.4z"
        fill="#1f3767"
      ></path>
      <path
        d="M10.3 5.9h2.4l.6 7.5 2.3-7.5h2l-3.9 12.9h-2.1l-.6-8.3h-.1l-2.5 8.3h-2zM21.1 5.9h3.1l-1.4 12.9h-2.3l.4-3.1h-2.7l-1.5 3.1h-2.1l6.5-12.9zm0 7.9l.7-5.4h-.1l-2.6 5.4h2zM25.9 5.9h2.3L27 14.7h.1l4.2-8.8h2l-6.4 13h-2.4zM35.7 7.8h-2.4l.6-1.9H41l-.5 1.9H38l-3.3 11h-2.3zM38.8 15.6l2-6.5c.7-2.2 2.6-3.4 4.6-3.4 2 0 3.3 1.1 2.6 3.3l-2 6.5c-.7 2.3-2.6 3.5-4.7 3.5s-3.2-1.1-2.5-3.4m4.8 0l2-6.7c.2-.8-.1-1.3-.9-1.3-.9 0-1.4.5-1.7 1.3l-2 6.6c-.2.8 0 1.4.9 1.4.9.1 1.5-.5 1.7-1.3M50 5.9h3.5c2.1 0 3 1.2 2.3 3.8-.6 1.8-1.5 2.9-2.6 3.4v5.8h-2.4l.2-5.3h-1l-1.6 5.3h-2.3l3.9-13zm1.5 6c.8 0 1.5-.6 1.9-2 .4-1.3.2-2-.7-2h-1l-1.2 4h1z"
        fill="#ffffff"
      ></path>
    </svg>
  </div>
  <div class="mt-2 flex gap-2 text-sm" data-testid="div-footer">
    <ng-content></ng-content>
  </div>
</div>
